module.exports = __webpack_public_path__ + "static/media/fav-icon.a558cb02.svg";